import { useState } from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";

import InputBox from "../General/InputBox";
import InputWrapper from "../../StylesWrappers/General/inputBox";
import SelectOption from "../General/SelectOption";
import Button from "../General/Button";
import ButtonWrapper from "../../StylesWrappers/General/button";

interface InputSectionProps {
  search: any;
  status: any;
  type: any;
  searchName: string;
  statusName: string;
  typeName: string;
  handleChange: any;
  handleSelect: any;
  handleClear: (e: React.FormEvent) => void;
}

const InputSection = ({
  search,
  status,
  type,
  searchName,
  typeName,
  statusName,
  handleChange,
  handleSelect,
  handleClear,
}: InputSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSearchToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <InputWrapper>
      <section className="search__header__con" onClick={handleSearchToggle}>
        <p>Search for job</p>
        {isOpen && <FaCaretDown />}
        {!isOpen && <FaCaretUp />}
      </section>
      <div
        className={`all__search ${
          !isOpen ? "add__all__jobs__search" : "all__jobs__search"
        }`}
      >
        <InputBox
          jobName="Search"
          typeName="text"
          inputName={searchName}
          inputValue={search}
          handleChange={handleChange}
        />
        <SelectOption
          statusName={statusName}
          statusValue={status}
          selectName="Status"
          optionOne="Pending"
          optionTwo="Interview"
          optionThree="Declined"
          valueOne="pending"
          valueTwo="interview"
          valueThree="declined"
          handleSelect={handleSelect}
        />
        <SelectOption
          statusName={typeName}
          statusValue={type}
          selectName="Job Type"
          optionOne="Full-time (on-site)"
          optionTwo="Full-time (remote)"
          optionThree="Part-time (on-site)"
          optionFour="Part-time (remote)"
          optionFive="Internship (on-site)"
          optionSix="Internship (remote)"
          optionSeven="Contract (on-site)"
          optionEight="Contract (remote)"
          optionController="jobType"
          valueOne="full-time-onsite"
          valueTwo="full-time-remote"
          valueThree="part-time-onsite"
          valueFour="part-time-remote"
          valueFive="internship-onsite"
          valueSix="internship-remote"
          valueSeven="contract-onsite"
          valueEight="contract-remote"
          handleSelect={handleSelect}
        />
        <ButtonWrapper>
          <Button
            button="Clear"
            handleSubmit={handleClear}
            type="submit"
            allJobsBtn="add-search-btn"
          />
        </ButtonWrapper>
      </div>
    </InputWrapper>
  );
};

export default InputSection;
